import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Topics from "@/pages/topics/page";
import TopicDetail from "@/pages/topics/detail/page";
import Guide from "@/pages/guide/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topics",
    element: <Topics />,
  },
  {
    path: "/topics/:slug",
    element: <TopicDetail />,
  },
  {
    path: "/guide",
    element: <Guide />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;